module.exports = __webpack_public_path__ + "media/images/mailer/confirmation_email_05-357c1fe1d0d1faaec45c83acce51e7cf.png";